




















import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import { isWeiXin } from '@/common/ts/common';
import { getBaseinfo } from '@/api/api';
import VoteButton from '@/components/VoteButton.vue';
import { OPTHINES } from './config';
import { Button, Toast, Dialog } from 'vant';

Vue.use(Button).use(Dialog);
@Component({
  components: {
    VoteList,
    VoteButton,
  },
})
export default class List extends Vue {
  option = OPTHINES;
  voteId: string = '';
  pointOut = false;
  newCoverArr: any[] = [];
  baseInfo = {};
  created() {
    // 登录成功后回调
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    getBaseinfo(this.option.voteName).then((res) => (this.baseInfo = res.data));
    setTimeout(() => {
      this.$appShareInfo({
        title: '重庆市“吃得文明”随手拍',
        url: window.location.href,
        subtitle: '晒出餐桌文明，享受健康人生',
        classId: -1,
        id: -1,
        image:
          'https://image2.cqcb.com/d/file/image/default/2020-07-21/d8b91d6156d9e2b759774c6b165ae460.jpeg',
        type: 3,
      });
    }, 500);
    this.$wxShareInfo({
      title: '重庆市“吃得文明”随手拍',
      subtitle: '晒出餐桌文明，享受健康人生',
      image:
        'https://image2.cqcb.com/d/file/image/default/2020-07-21/d8b91d6156d9e2b759774c6b165ae460.jpeg',
    });
    //     const res = await detailUser();
    // switch ((res as any).code) {
    //   case 200:
    //     for (const imgItem of res.data.cover as any) {
    //       const img = { cover: imgItem, path: imgItem };
    //       this.newCoverArr.push({ cover: imgItem, path: imgItem });
    //     }
    //     console.log(
    //       '上次上传了图片!!:',
    //       this.newCoverArr,
    //       this.presetFilesImages,
    //     );
    // }
  }
  chooseFun(e: any) {
    const newArr = new Set(e);
    let lastArr = [];
    lastArr = Array.from(newArr);
    console.log('e', lastArr);

    this.voteId = JSON.stringify(lastArr);
    console.log('voteId', this.voteId);
  }
  votSuccess() {
    console.log('success');
    Toast.success('投票成功');
    setTimeout(() => {
      this.$router.go(0);
    }, 500);
  }
  enterUpload() {
    if (!window.udid) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行报名',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else {
      if (window.gettoken() === '' || window.gettoken() === 'null') {
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
      } else {
        this.$router.push({ path: './Uploading' });
      }
    }
  }
}
